@if (initialized) {
  <!-- <div *ngIf="!projectReports.length" class="mat-body-strong">Found no reports to show</div> -->
  <!-- Status card -->
  <div class="status-container">
    @for (pr of statuses; track pr) {
      <div
        [class.active]="pr.status == 'signed'"
        [class.error]="pr.status == 'rejected'"
        [class.in-progress]="pr.status == 'submitted'"
        class="status-card">
        <div class="mat-subtitle-1">
          <a
            [routerLink]="pr.status !== 'todo' ? [pr.project_id, 'project-report', pr.id] : []"
            class="no-style"
            [class.link]="pr.status !== 'todo'">
            {{ pr.report_date | dateFormat: 'long' }}
          </a>
        </div>
        <div class="mat-caption">
          @switch (pr.status) {
            @case ('todo') {
              Awaiting creation
            }
            @case ('draft') {
              Awaiting submission
            }
            @case ('submitted') {
              Sent for signature
            }
            @case ('rejected') {
              Rejected
            }
            @case ('signed') {
              Signed off
            }
          }
        </div>
      </div>
    }
  </div>
  <!-- /Status card -->
}
